import {
  Autocomplete,
  TextField,
  InputLabel,
  Chip,
  Avatar,
  Tooltip,
} from "@mui/material";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
export default function SpeakersView(props) {
  function getSpeakerDtls(id) {
    if (id) {
      let position = props?.data.findIndex((element) => element.spkId === id);
      if (position > -1) {
        return props?.data[position];
      }
    }
    // Return a fallback object if speaker not found
    return {
      name: "Unknown Speaker",
      profileImage: null,
      spkId: id
    };
  }
  function handleOnChange(value) {
    let array = [...props.selectedValue];
    array.push({"speakerId":value[0]?.spkId, "order":value[0]?.order});
    props.setSelectedValue(array);
  }
  function handleDelete(chipToDelete) {
    props.setSelectedValue((chips) => {
      return chips.filter((chip) => chip?.speakerId !== chipToDelete);
    });
  }
  function getSpeakerIdArray() {
    let array = [];
    props.selectedValue.forEach((element) => {
      array.push(element.speakerId);
    });
    return array;
  }
  const filterOptions = (options, { inputValue }) => {
    let array = [];
    let selectedIds = getSpeakerIdArray();
    
    options.forEach((element) => {
      if (inputValue) {
        if (
          element.name.toLowerCase().includes(inputValue.toLowerCase()) &&
          !selectedIds.includes(element?.spkId)
        ) {
          array.push(element);
        }
      } else if (!selectedIds.includes(element?.spkId)) {
        array.push(element);
      }
    });
    return array;
  };
  function handleOnDragEnd(result) {
    if (!result.destination) return;
  
    const items = Array.from(props.selectedValue);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
  
    // Update the order based on the new index
    const updatedItems = items.map((item, index) => ({
      ...item,
      order: index , // assuming order starts from 0
    }));
  
    props.setSelectedValue(updatedItems);
  
  }
  return (
    <div className="card mb-4">
      <div className="card-title justify-content-between">
        <div className="d-flex">
          <img src="../../assets/images/Group.svg" /> Speaker
        </div>
        <a
          onClick={() => {
            props.setOpenAdd(true);
          }}
          className="addspeaker-btn"
          // href="javscript:;"
        >
          <img src="../../assets/images/adduser.svg" />
          Add Speaker
        </a>
      </div>
      <div className="card-body speaker-select-outer">
        <div className="row">
          <div className="col-md-12 mb-3">
            <InputLabel className="form-label">Select speaker</InputLabel>
            <Autocomplete
              multiple
              filterOptions={filterOptions}
              options={props?.data ? props?.data : []}
              value={[]}
              getOptionLabel={(options) => options.name}
              filterSelectedOptions
              renderInput={(params) => (
                <TextField
                  {...params}
                  //   label="type"
                  placeholder="Type"
                />
              )}
              renderOption={(props, option) => (
                <li {...props} key={option?.spkId}>
                  {option?.name}
                </li>
              )}
              onChange={(e, value) => {
                handleOnChange(value);
              }}
            />
          </div>
          <div className="col-sm-12">
            <div>
              <p className="speakers-head">Speakers:</p>
              {/* <div className="selected-speakers">
                {props.selectedValue.map((item) => (
                  <Chip
                    avatar={
                      <Avatar src={getSpeakerDtls(item)?.profileImage}>
                        {getSpeakerDtls(item)?.name?.[0].toUpperCase()}
                      </Avatar>
                    }
                    label={getSpeakerDtls(item)?.name}
                    variant="outlined"
                    onDelete={() => handleDelete(item)}
                  />
                ))}
              </div> */}
              <DragDropContext onDragEnd={handleOnDragEnd}>
              <Droppable droppableId="users">
                {(provided) => (
                  <div {...provided.droppableProps} ref={provided.innerRef}>
                    {props.selectedValue.map((item,index) => (
                        <Draggable draggableId={item.speakerId} index={index} key={item.speakerId}>
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={{
                                ...provided.draggableProps.style,
                                maxWidth: '800px', // or a specific pixel value
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                              }}
                              className="w-100 d-flex justify-content-between px-3 ps-2 pe-3 py-1 rounded border bg-light mt-3 mb-3"
                            >
                              <div className="d-flex align-items-center gap-2">
                                <Tooltip title="Drag to reorder">
                                <img className="me-2" src="../../assets/images/drag.svg" alt="Drag" />
                                </Tooltip>
                                <Avatar style={{ width: "20px", height: "20px" }} src={getSpeakerDtls(item?.speakerId)?.profileImage}>
                                {getSpeakerDtls(item?.speakerId)?.name?.[0].toUpperCase()}                
                                </Avatar>
                                <div className="text-secondary">{getSpeakerDtls(item?.speakerId)?.name}</div>
                              </div>
                              <div
                                className="cursor-pointer"
                                type="button"
                                onClick={() => handleDelete(item?.speakerId)}
                              >
                                <img src="../../assets/images/close-drag.svg" alt="Close" />
                              </div>
                            </div>
                          )}
                        </Draggable>
                       ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
